var quantityLabel = "Antal";
var quantityFlyoutHeader = "Välj antal";
var quantityFlyoutCTA = "Välj det här antalet";
var closeButton = "Stäng";
var pricePlaceholder = "...";
var priceLabel = "Pris";
var unitPriceLabel = "Pris per enhet";
var incompatibilityMessage = "Går inte att välja med andra val: ";
var select = "Välj...";
var percentSavings = "{{{PERCENT}}} % rabatt";
var sale = "rea";
var amountSavings = "{{{AMOUNT}}} rabatt / enhet";
var amountSavingsWithSale = "{{{AMOUNT}}} rabatt / enhet + rea";
var seeMoreQuantities = "Se fler antal";
var required = "Obligatoriskt";
var sample = "Varuprov";
var estimatedQuantity = "Beräknat antal";
var numberOfRecipients = "{{{COUNT}}} Mottagare";
var recommendedCallout = "Rekommenderas";
var newCallout = "Nyhet";
var incompatibleLabel = "Ej kompatibel";
var outOfStockCallout = "Ej i lager";
var dismissAlert = "Avvisa avisering";
var unwindingMessage_1 = "Ej kompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Ej kompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}} eller {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Ej kompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} eller {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Ej kompatibel med mer än {{{ATTRIBUTE_COUNT}}} alternativ.";
var unwindingAlertMessage_1 = "För att bli kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: avmarkerades {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingAlertMessage_2 = "För att bli kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: avmarkerades {{{ATTRIBUTE1}}} {{{OPTION1}}} och {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingAlertMessage_3 = "För att bli kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: avmarkerades {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} och {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingAlertMessage_more = "För att bli kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: avmarkerades fler än {{{ATTRIBUTE_COUNT}}} alternativ.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} till {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Minst {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Ange ett värde mellan {{{MINIMUM}}} och {{{MAXIMUM}}} sidor, inklusive omslag ";
var rangePartialRangedHelperTextForBooklets = "Minst {{{MINIMUM}}} sidor, inklusive omslag ";
var rangedGeneralInputError = "Inmatningen är ogiltig";
var rangedBetweenRangesError = "De närmaste talen är {{{LOWER}}} {{{UNIT}}} och {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "Talet får ha högst 8 decimaler";
var rangedMinInputValueError = "Lägsta giltiga tal är {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "Högsta giltiga tal är {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "Inmatningen måste vara ett tal";
var requiredAttributeFieldError = "Ange ett värde mellan {{{LOWER}}} och {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Det närmaste talet är {{{LOWER}}} sidor och {{{HIGHER}}} sidor ";
var rangedMinInputValueErrorForBooklets = "Lägsta giltiga tal är {{{MINIMUM}}} sidor ";
var rangedMaxInputValueErrorForBooklets = "Högsta giltiga tal är {{{MAXIMUM}}} sidor ";
var requiredAttributeFieldErrorForBooklets = "Ange ett värde mellan {{{LOWER}}} och {{{HIGHER}}} sidor, inklusive omslag ";
var requiredInformationToast = "Ange all obligatorisk information, tack.";
var svSe = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, svSe as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=sv-se.json.mjs.map
